import React from 'react';
import PropTypes from 'prop-types';
import { addLocaleData, IntlProvider, injectIntl } from 'react-intl';
import en from 'react-intl/locale-data/en';
import es from 'react-intl/locale-data/es';
import Main from './instructional_feed_components/Main';
import instructionalFeedComponents from '../locales/instructional_feed.json';
import defaultLocales from '../locales/default.json';

addLocaleData([...es, ...en]);

export const injectInstructionalFeed = Comp => props => (
  <InstructionalFeed {...props}>
    <Comp {...props} />
  </InstructionalFeed>
);

const InstructionalFeed = injectIntl(({ className, ...props }) => {
  const { locale } = props.intl;
  const messages = {
    ...instructionalFeedComponents[locale],
    ...defaultLocales[locale],
  };

  return (
    <div className={`instructional-feed ${className}`}>
      <IntlProvider
        locale={locale}
        messages={{ ...props.intl.messages, ...messages }}
      >
        <Main {...props} />
      </IntlProvider>
    </div>
  );
});

InstructionalFeed.defaultProps = {
  className: '',
  onHide: () => {},

  // extends main defaults props
  ...Main.defaultProps,
};

InstructionalFeed.propTypes = {
  className: PropTypes.string,

  // extends main props types
  ...Main.propTypes,
};

export default InstructionalFeed;
